(() => {
  if (typeof window.customElements.get('affinity-discount') !== 'undefined') { return }

  window.customElements.define('affinity-discount', class AffinityDiscount extends HTMLElement { // eslint-disable-line
    constructor() {
      super()

      this.discountQueryParams = this.getAttribute('data-affinity-discount-query-params')
      this.idQueryParams = this.getAttribute('data-affinity-id-query-params')
      this.customerEmail = this.getAttribute('data-customer-email')
    }

    connectedCallback() {
      this.getUtmSource()

      this.initAffinityDiscountCartAttributes()
      this.updateCustomerUtmEvents()
    }

    getUtmSource() {
      const urlParams = new URLSearchParams(window.location.search)
      const urlUtmSource = urlParams.get('utm_source')
      if (!urlUtmSource) return
      window.sessionStorage.setItem('utm_source', urlUtmSource)
      this.utmSource = urlUtmSource
    }

    /**
     * Checks session storage for utmSource on login
     * Updates the customer's utmSource on the server
     * Removes utmSource from session storage
     * Removes utmSource from cart attributes
     * @returns {Promise<void>}
     */
    async updateCustomerUtmEvents() {
      if (!this.utmSource) return
      if (!this.customerEmail) return
      this.customerEmail = this.customerEmail.trim()

      const data = {
        email: this.customerEmail,
        utmSource: this.utmSource
      }

      console.log({ data })

      try {
        const idUpdateRes = await fetch(`${window.apiUrl}/customer/utm-events`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('LRTokenKey')}`,
          },
          body: JSON.stringify(data)
        })

        const updateData = await idUpdateRes.json();
        console.log({ updateData })

        // Remove session storage item
        window.sessionStorage.removeItem('utm_source')

        // Remove utmSource from cart attributes
        this.updateCartAttributes({ utmSource: null });

        return updateData
      } catch (error) {
        console.error('There was a problem updating the customer:', error)
      }
    }

    async initAffinityDiscountCartAttributes() {
      try {
        const discountAttr = this.getAffinityUTMAttribute()
        const idAttr = this.getAffinityIdAttribute()
        let attributes = {
          ...discountAttr,
          ...idAttr,
        }

        const utmSource = this.utmSource
        if (!this.customerEmail && utmSource) {
          attributes.utm_source = utmSource
        }

        if (!Object.keys(attributes).length) { return }

        await this.updateCartAttributes(attributes)
      } catch (error) {
        console.error('There was a problem with the AffinityDiscount component:', error)
      }
    }

    /**
     * Gets the UTM parameter from the URL params
     * @returns {Object} - Cart attribute containing the UTM parameter
     */
    getAffinityUTMAttribute() {
      if (!this.discountQueryParams || this.discountQueryParams === '') { return {} }

      this.discountQueryParamsArray = this.discountQueryParams.split(',').map(param => param.trim())

      const urlParams = new URLSearchParams(window.location.search)
      const matchingParamKey = this.discountQueryParamsArray.find(param => urlParams.has(param))
      const affinityValue = matchingParamKey ? urlParams.get(matchingParamKey) : null

      if (!affinityValue) { return {} }

      return {
        affinity_discount: affinityValue
      }
    }

    /**
     * Gets the affinity ID attribute from the URL params
     * Sets the ID as a session storage item
     * @returns {Object} - Cart attribute containing the customer's affinity ID
     */
    getAffinityIdAttribute() {
      // Check if the customer email is set, if so, do not set the ID as a session storage item
      if (!this.idQueryParams || this.idQueryParams === '' || this.customerEmail) { return {} }

      this.idQueryParamsArray = this.idQueryParams.split(',').map(param => param.trim())

      const urlParams = new URLSearchParams(window.location.search)
      const matchingParamKey = this.idQueryParamsArray.find(param => urlParams.has(param))
      const idValue = matchingParamKey ? urlParams.get(matchingParamKey) : null

      if (!idValue) { return {} }

      window.sessionStorage.setItem(matchingParamKey, idValue)

      return {
        [matchingParamKey]: idValue
      }
    }

    async updateCartAttributes(attributes) {
      console.log('updateCartAttributes', attributes)
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes
        })
      })
    }
  })
})()